import PropTypes from 'prop-types';
import { useRouter } from 'next/router';

import { analytics, getFilterApply } from '@/utils/analytics';

import Text from '@/atoms/Text/Text';
import FilterDropdown from '@/molecules/FilterDropdown/FilterDropdown';
import { isWHEnv } from '@/utils/helper';

function Filters({ fields }) {
  const { tagGroupsWithTags, queryTagsKey, name } = fields;

  //if there is no tagGroups found show nothing
  if (tagGroupsWithTags.length === 0) return null;

  const getApplyAnalytics = (searchUrl = '', e) => {
    const urlParams = searchUrl?.split(',');
    if (!tagGroupsWithTags?.length || !urlParams?.length) return;

    const activeTagGroups = tagGroupsWithTags.reduce(
      (activeGroup = {}, { name, tags }) => {
        if (!tags?.length) return activeGroup;

        const selectedTags = tags
          .filter(({ slug }) => urlParams.includes(slug))
          ?.map(({ slug }) => slug);

        return {
          ...activeGroup,
          [`filter_${name.toLowerCase().replace(/\s/, '_')}`]:
            selectedTags?.length ? selectedTags.join(',') : null,
        };
      },
      {}
    );

    analytics({
      window,
      document,
      detail: getFilterApply(e, activeTagGroups, { name }),
    });
  };

  return (
    <div className="aaco-filters container dd-kr:max-w-7xl dd-en:max-w-7xl dd-kr:px-0 dd-en:px-0 mx-auto flex flex-col md:flex-row md:items-center md:gap-x-7 md:py-9 md:px-16">
      <Text tag={isWHEnv() ? "body" : "tag"} style="dd-kr:text-dark-warm-grey dd-en:text-dark-warm-grey text-acacia mr-7 mb-5 md:mb-0">
        EXPLORE BY:
      </Text>
      {tagGroupsWithTags.map((i) => (
        <FilterDropdown
        key={i.id}
        name={i.name}
        slug={i.slug}
        tags={i.tags}
        queryTagsKey={queryTagsKey}
        getApplyAnalytics={getApplyAnalytics}
      />
    ))}
  </div>
);
}

Filters.propTypes = {
assets: PropTypes.array,
entries: PropTypes.array,
fields: PropTypes.object,
};

export default Filters;
